<template>
  <div>
    <Spinner v-if="isGettingMemberInfo" />
    <div v-else class="flex flex-col justify-between">
      <div class="mx-auto w-full max-w-3xl py-20 bg-white">
        <h1 class="h2">{{ disclaimer.name }}</h1>
        <Markdown :source="disclaimer.text" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Markdown from '../common/Markdown'

export default {
  components: { Markdown },
  props: {
    disclaimerId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    ...mapGetters('member', ['disclaimerById', 'isGettingMemberInfo']),
    disclaimer() {
      return this.disclaimerById(this.disclaimerId)
    },
  },
}
</script>

<style></style>
